// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3_MTU","header":"ReportDetails_header__7aUhC","title":"ReportDetails_title__3F061","left":"ReportDetails_left__g42Z0"};